import { uniqBy } from 'lodash';

export default function WaveData(currentMode, currentArea, datas) {
  let filterAreaData = [];
  const mode = currentMode;
  const area = currentArea;
  if (mode === 'province' && area.code !== '0') {
    // filterAreaData = datas.filter((d) => d.station.province_code === area.code);
    filterAreaData = datas.filter((d) => d.swan_station.province_code === area.code);
  } else if (mode === 'basin' && area.code !== '0') {
    filterAreaData = datas.filter((d) => d.swan_station.basin_code === parseInt(area.code, 10));
  } else {
    filterAreaData = datas;
  }

  // แสดงรายชื่อจังหวัดที่มีความสูงคลื่นมากกว่า 2 เมตร
  // highsig ข้อมูลคาดการณ์ความสูงของคลื่น หน่วย m
  const dataFilterArea = filterAreaData.filter((d) => d.highsig > 2)
    .map((row) => ({
      wave_height: row.highsig,
      name: row.swan_station.province_name.th,
      tele_station_name: row.swan_station.name,
      tele_station_lat: row.swan_station.lat,
      tele_station_long: row.swan_station.long,
      province_code: row.swan_station.province_code,
      province_name: row.swan_station.province_name,
    }));

  const varRed = uniqBy(dataFilterArea, 'name').sort((a, b) => a.name.localeCompare(b.name, 'th'));
  const waveCount = (varRed.length);

  const waveList = {
    count: waveCount,
    red: varRed,
  };

  return ({
    waveCount,
    waveList,
    waveDataFilterArea: dataFilterArea,
  });
}
